module.exports = __webpack_public_path__ + "static/img/logo20.9031267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo20.png
// module id = nhE1
// module chunks = 2